import get from 'lodash/get';
import React, {useEffect} from 'react';
import {useLocation, useParams, useNavigate} from 'react-router-dom';
import {Helmet} from 'react-helmet';

import Container from '@mui/material/Container';

import PublicLayout from '../layouts/PublicLayout';
import AppDashboard from '../AppDashboard';
import ViewProvider from '../../components/providers/ViewProvider';
import {formatProviderName,isPersonalTrainer} from '../../helpers/providers';
import useUser from '../../hooks/useUser';

import {useGetProvidersQuery} from '../../redux/services/providerApi';
import {useGetHighlightsQuery} from '../../redux/services/providerHighlightApi';
import {useGetReviewsQuery} from '../../redux/services/reviewApi';
import useProviderProfileRedirect from '../../hooks/useProviderProfileRedirect';

const ViewProviderPage = props => {
  const {id, slug} = useParams();
  const user = useUser();
  const providerQuery = useGetProvidersQuery(
    slug ? {slug, is_hidden: false} : {id, is_hidden: false}, 
    {skip: !id && !slug}
  );
  const highlightsQuery = useGetHighlightsQuery(null, {skip: false});
  const provider = get(providerQuery, 'data[0]', null);
  const reviewsQuery = useGetReviewsQuery(
    {provider_id: id || provider?.id}, 
    {skip: !id && !provider?.id}
  );
  const providerType = isPersonalTrainer(provider) ? 'Personal Trainer' : 'Physical Therapist';
  useProviderProfileRedirect(provider);
  const city = get(provider, 'primary_location', '');
  const metaTitle = `${formatProviderName(provider)} - MovementX ${providerType} in ${city}`;
  const metaDescription = `Meet ${formatProviderName(provider)}, a MovementX ${providerType} in ${city}. Learn more about our specialized services and schedule your first session today.`;
  const isProvider = get(user, 'is_provider', false);
  const childProps = {
    ...props,
    provider,
    user,
    isProvider,
    disableAddReview: false,
    reviews: get(reviewsQuery, 'data', []),
    highlights: get(highlightsQuery, 'data', []),
    loading: (
      providerQuery.isLoading
      || highlightsQuery.isLoading
    ),
    error: (
      providerQuery.error
      || highlightsQuery.error
    ),
  };
  // FIXME: What is the primary location for a provider?
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name='description'content={metaDescription} />
        {/*<link rel="canonical" href="http://mysite.com/example" />*/}
      </Helmet>
      {
        user ?
        <AppDashboard loading={childProps.loading} skipAuth={true} title='Settings'>
          {
            childProps.provider && !childProps.loading
            ? <ViewProvider {...childProps} />
            : null
          }
        </AppDashboard>
        : (childProps.provider && 
          <PublicLayout>
            <Container>
              <ViewProvider {...childProps} />
            </Container>
          </PublicLayout>
        )
      }
    </>
  );
};

export default ViewProviderPage;
